import React, { memo, useCallback, useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroller';
import { useDispatch, useSelector } from 'react-redux';
import { createSelector } from 'reselect';
import { getMessageList, resetMessageList } from '../../../actions/message';
import avatarV from '../../../static/f_user_v.png';
import avatarDefault from '../../../static/forum_default_header.svg';
import styles from './Invite.module.less';
import { CONTEXT, MICROCONTEXT } from '../../../config';
import { useHistory } from 'react-router-dom';
import { setMessageVisible } from '../../../actions/layout';
import { logging } from '../../../actions/log';

const selectMessage = createSelector(
  state => state.message,
  message => ({
    inviteList: message.inviteList || [],
    messageHot: message.hot,
    invitePagenation: message.invitePagenation,
    inviteLoading: message.inviteLoading,
  }),
);
const selectLogInfo = createSelector(
  state => state.log,
  log => log.logInfo,
);
export default memo(() => {
  const [node, setNode] = useState(null);
  const history = useHistory();
  const dispatch = useDispatch();
  const { inviteList, invitePagenation, inviteLoading } = useSelector(selectMessage);
  const [loadCount, setLoadCount] = useState(0);
  const logInfoData = useSelector(selectLogInfo);

  const loadMore = useCallback(() => {
    if (!inviteLoading) {
      dispatch(getMessageList({ code: 4, skip: inviteList.length, limit: 24, refresh: false }));
    }
  });

  useEffect(() => {
    if (inviteList && inviteList.length > 0) {
      let ids = inviteList.slice(loadCount).map(el => {
        return el.id;
      });
      if (ids && ids.length > 0) {
        dispatch(
          logging({
            category: 'I',
            action: 'Forum_Show',
            label: '',
            param2: {
              id: ids,
              source: 'Message_Respond',
              source_p: logInfoData.source_p,
              source_pp: logInfoData.source_pp,
            },
          }),
        );
        setLoadCount(inviteList.length);
      }
    }
  }, [inviteList, loadCount, dispatch]);
  const handleSkipLog = useCallback(id => {
    dispatch(
      logging({
        category: 'C',
        action: 'Message_Response_Forum',
        label: '',
        param2: {
          id: id,
          source: 'Message_Respond',
          source_p: logInfoData.source_p,
          source_pp: logInfoData.source_pp,
        },
      }),
    );
  }, []);

  return (
    <div className={styles.invite} ref={r => setNode(r)}>
      <InfiniteScroll
        pageStart={1}
        loadMore={loadMore}
        hasMore={inviteList.length < invitePagenation.count}
        loader={
          <div className="loader" key={0}>
            ----------加载中----------
          </div>
        }
        initialLoad={false}
        useWindow={false}
        getScrollParent={() => node}
      >
        {inviteList &&
          inviteList.map(el => (
            <div
              className={styles.invite_line}
              key={el.id}
              onClick={() => {
                dispatch(setMessageVisible(false));
                dispatch(resetMessageList());
                handleSkipLog(el.id);
                history.push(`${CONTEXT}${MICROCONTEXT}${MICROCONTEXT}/forumdetail?id=${el.id}`);
              }}
            >
              <div className={styles.invite_info}>
                <div className={styles.invite_avatar_box}>
                  <img src={el.userAvatar || avatarDefault} className={styles.invite_avatar_img} />
                  {el.isV === 1 && <img src={avatarV} className={styles.invite_avatar_v} />}
                </div>
                <div className={styles.invite_name}>Ta等着你回答</div>
                <div className={styles.invite_title}>{el.title}</div>
              </div>
              <div className={styles.invite_time}>{el.pushTimeDesc}</div>
            </div>
          ))}
      </InfiniteScroll>
    </div>
  );
});
